<template>
  <div :class="['setting', $store.state.app.web_language_wm !== 'en' ? 'c-custom_setting' : '']">
    <el-tabs v-model="activeName">
      <el-tab-pane :label="$t('view_left_sidebar_setting_277')" name="basic">
        <div class="tab_content">
          <my_input
            titleWidth="auto"
            :title="$t('view_left_sidebar_setting_278')"
            :value.sync="$store.state.myRender.common.setting.title"
            type="one_level"
          ></my_input>
          <div class="line_border"></div>
          <my_collapse v-model="collapseName" @change-item="change_collapse_item">
            <my_collapse_item :title="$t('view_right_set_index_56')" name="basics">
              <div class="checkbox_item">
                <el-checkbox
                  v-model="$store.state.myRender.common.setting.logoTitleRadio"
                  @change="(e)=>{title_nav_isShow(e,'basic_webtitle')}"
                >{{$t('view_left_sidebar_setting_279')}}</el-checkbox>
                <span
                  v-if="$store.state.myRender.common.setting.logoTitleRadio"
                  @click="open_set('basic_webtitle')"
                >{{$t('view_right_set_index_58')}}</span>
              </div>
              <div class="checkbox_item">
                <el-checkbox
                  v-model="$store.state.myRender.common.setting.headerNavRadio"
                  @change="(e)=>{title_nav_isShow(e,'basic_navbar')}"
                >{{$t('view_left_sidebar_setting_280')}}</el-checkbox>
                <span
                  v-if="$store.state.myRender.common.setting.headerNavRadio"
                  @click="open_set('basic_navbar')"
                >{{$t('view_right_set_index_58')}}</span>
              </div>
              <div class="checkbox_item">
                <el-checkbox v-model="$store.state.myRender.private.banner_isShow">{{$t('view_left_sidebar_setting_281')}}</el-checkbox>
                <span
                  v-if="$store.state.myRender.private.banner_isShow"
                  @click="open_set('full_screen_banner')"
                >{{$t('view_right_set_index_58')}}</span>
              </div>
              <div class="checkbox_item">
                <el-checkbox v-model="$store.state.myRender.common.setting.returnTopRadio">{{$t('view_back_top_edit_94')}}</el-checkbox>
              </div>
              
              <div class="checkbox_item" v-if="$store.state.app.language !== 'zh-cn'">
                <el-checkbox
                  v-model="$store.state.myRender.common.setting.multiLanguageOpen"
                  @change="(e)=>{multi_language_isShow(e,'basic_language')}"
                >{{$t('view_left_sidebar_setting_282')}}</el-checkbox>
                <span
                  v-if="$store.state.myRender.common.setting.multiLanguageOpen"
                  @click="open_set('basic_language')"
                >{{$t('view_right_set_index_58')}}</span>
              </div>
              <template v-if="$store.state.app.language == 'zh-cn'">
              <div class="checkbox_item">
                <el-checkbox
                  v-model="$store.state.myRender.common.setting.zhLanguageOpen"
                  @change="(e)=>{zh_language_isShow(e,'basic_zhlanguage')}"
                >{{$t('view_left_sidebar_setting_283')}}</el-checkbox>
                <span
                  v-if="$store.state.myRender.common.setting.zhLanguageOpen"
                  @click="open_set('basic_zhlanguage')"
                >{{$t('view_right_set_index_58')}}</span>
              </div>
             
                <my_input
                v-if="$store.state.myRender.common.setting.zhLanguageOpen"
                style="margin:0;"
                titleWidth="82"
                :title="$t('view_left_sidebar_setting_284')"
                :placeholder="$t('view_left_sidebar_setting_285')"
                @blur="zhLanguageAdressChange"
                :value.sync="$store.state.myRender.common.setting.zhLanguageAdress"
                type="one_level"
                width="270"
              ></my_input>
              </template>
              <div class="checkbox_item" v-if="$store.state.app.now_page == 'index'">
                <el-checkbox
                  v-model="$store.state.myRender.private.H1_isOpen"
                  @change="h1_add_isShow"
                >{{$t('view_left_sidebar_setting_286')}}</el-checkbox>
                <span
                  v-if="$store.state.myRender.private.H1_isOpen"
                  @click="open_set('basic_h1')"
                >{{$t('view_right_set_index_58')}}</span>
              </div>
              <div class="checkbox_item"
                   v-if="$store.state.vip.switch && $store.state.app.language == 'zh-cn' && zxtVisible">{{$t('view_left_sidebar_setting_287')}}<el-select
                  v-model="$store.state.myRender.common.vip_type"
                  size="small"
                  @change="change_vip_type"
                >
                  <el-option
                    v-for="item in filter.vipTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="checkbox_item"
                   v-if="$store.state.vip.switch && $store.state.app.language == 'zh-cn' && zxtVisible">{{$t('view_left_sidebar_setting_288')}}<el-select
                  v-model="$store.state.myRender.common.vip_type_footer"
                  size="small"
                  @change="change_vip_type_footer"
                >
                  <el-option
                    v-for="item in filter.vipTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <!-- 浮框设置 -->
              <div class="checkbox_item">
                <el-checkbox
                  v-model="$store.state.myRender.private.floatingFrameOpen">{{$t('view_left_sidebar_setting_289')}}</el-checkbox>
                <span
                  v-if="$store.state.myRender.private.floatingFrameOpen"
                  @click="open_set_floating_frame('basic_floating_frame')"
                >{{$t('view_right_set_index_58')}}</span>
              </div>

             
              <!-- contact_us 联系我们 -->
              <!-- 联系我们 这边添加判断条件 国内站的这边如果没有勾选的情况下这边就不能够显示了  -->
              <div class="checkbox_item" v-if="contact_us_show">
                <el-checkbox v-model="$store.state.myRender.common.contact_us.contact_us_show" @change="contact_us_change">contact us</el-checkbox>
              </div>

               <!-- 登录 注册头部  登录注册 这边再点击勾选登录注册之后 要创建一个通栏 放置在header中的第一个部分-->
              <div class="checkbox_item" v-if="$store.state.login_type.register_set">
                <el-checkbox v-model="$store.state.myRender.common.setting.loginRegister" @change="login_register_change">{{$t('view_left_sidebar_setting_290')}}</el-checkbox>
              </div>
              
              <div class="checkbox_item" v-if="$store.state.login_type.register_set">
                  <el-checkbox v-model="$store.state.myRender.common.setting.shoppingCart" @change="login_register_change">{{$t('view_left_sidebar_setting_291')}}</el-checkbox>
              </div>

              <!-- contact_us_show -->
              <!-- <my_radio
                titleWidth="65"
                :selectValue.sync="$store.state.myRender.common.previewModule"
                hiddenIsShow="false"
                title="预览模式："
                :option="filter.previewModuleOptions"
              ></my_radio>-->
            </my_collapse_item>
           
          </my_collapse>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="高级设置" name="header">
        <div class="tab_content">高级设置</div>
      </el-tab-pane>-->
    </el-tabs>
  </div>
</template>

<script>
import i18n from '../../language/index'

import Module from '@/base/one_module'

export default {
  name: 'setting',
  data() {
    return {
      activeName: 'basic',
      collapseName: ['basics'],
      filter: {
        previewModuleOptions: [
          {
            label: i18n.t('view_left_sidebar_setting_292'),
            value: 'this'
          },
          {
            label: i18n.t('view_left_sidebar_setting_293'),
            value: 'new'
          }
        ],
        vipTypeOptions: [
          {
            label: i18n.t('view_back_top_edit_103'),
            value: 'default'
          },
          {
            label: i18n.t('view_back_top_edit_102'),
            value: 'custom'
          }
        ]
      },
      copy_contact: this.$store.state.myRender.common.contact_us.contact_us_show
    }
  },
  computed: {
    setting() {
      return this.$store.state.myRender.common.setting
    },
    banner() {
      const view_pattern = this.$store.state.app.view_pattern
      return this.templet.find_banner()[view_pattern + '_banner']
    },
    zxtVisible() {
      return Number(this.$store.state.app.road_type) !== 1
    },
    is_road_type() {
      return this.$store.getters['app/is_road_type']
    },
    contact_us_show() { // 外贸站 或者 联系我们是true的情况
      return this.is_road_type || this.copy_contact
    }
  },
  watch: {
    '$store.state.myRender.common.setting.returnTopRadio': function (v) {
      this.$store.commit('myRender/SET_show_back_top', v)
    },
    '$store.state.myRender.common.setting.loginRegister'(val){
      this.$store.commit('myRender/SET_show_login_register', val)
    }
  },
  methods: {
    zhLanguageAdressChange(val) {
      if(val.substr(0,7).toLowerCase() == "http://" || val.substr(0,8).toLowerCase() == "https://" || val.substr(0,6).toLowerCase() == "ftp://"){
          this.$store.state.myRender.common.setting.zhLanguageAdress = val;
      }else{
          this.$store.state.myRender.common.setting.zhLanguageAdress = "http://" + val;
      }
    },
    change_collapse_item(item) {
      if (item.status) {
        // 打开面板后重新绑定值
        this.$nextTick(() => {
          this.templet.left_sidebar_draggable()
        })
      }
    },
    open_set(name) {
      const id = $('.' + name).attr('data-id')
      const module = this.templet.find_obj(id)
      console.log(module, name)
      if (module) {
        this.$store.commit('app/SET_module_Data', module.target)
        this.$store.commit('main_dialog/Change_main_dialog_isShow', true)
        this.$store.commit('main_dialog/Change_edit_name', name)
      } else if(this.$store.state.myRender.common.header_display === 'false' 
      || this.$store.state.myRender.common.footer_display === 'false'){
            this.$message({
            showClose: true,
            type: 'warning',
            message: i18n.t('view_left_sidebar_setting_294')
          });
      }
    },
    title_nav_isShow(val, name) {
      if (val) {
        this.templet.title_nav_isShow(name)
      }
    },
    h1_add_isShow(e) {
      if (e) {
        this.templet.h1_add_isShow()
      }
    },
    multi_language_isShow(val, name) {
      if (val) {
        this.templet.multi_language_isShow(name)
      }
    },
    zh_language_isShow(val, name) {
      if (val) {
        this.templet.zh_language_isShow(name)
      }
    },
    change_vip_type(type) {
      if (type === 'default') {
        this.templet.del_vip_header()
      }
      if (type === 'custom') {
        this.templet.create_vip_header()
      }
    },
    change_vip_type_footer(type) {
      if (type === 'default') {
        this.templet.del_vip_footer()
      }
      if (type === 'custom') {
        this.templet.create_vip_footer()
      }
    },
    open_set_floating_frame(name) {
      let module = this.$store.state.myRender.private.floatingFrameStyle
      this.$store.commit('app/SET_module_Data', module)
      this.$store.commit('main_dialog/Change_main_dialog_isShow', true)
      this.$store.commit('main_dialog/Change_edit_name', name)
    },
    login_register_change(){ // 选择 去掉登录注册的数据 去创建通栏设置数据
      this.$store.commit('app/SET_is_change', true);
      this.templet.create_login_register()
    },
    contact_us_change(val) { // 选择显示 contact us
      if(!this.is_road_type && !val) this.$message.warning(i18n.t('view_left_sidebar_setting_295'))
      this.$store.commit('myRender/set_contact_us_show', val);
    }
  }
}
</script>

<style lang="scss" scoped>
.setting {
  /deep/ .el-tabs {
    .el-tabs__header {
      margin: 0;
      padding-left: 20px;
      height: 50px;
      background: #f5f5f5;

      .el-tabs__nav-wrap::after {
        background: transparent;
      }

      .el-tabs__active-bar {
        // width: 60px;
      }

      .el-tabs__item {
        height: 50px;
        padding: 0;
        padding-right: 20px;
        line-height: 50px;
        color: #999999;
        font-size: 14px;

        &.is-active {
          color: #0078d7;
          background: transparent;
        }
      }
    }
  }

  .tab_content {
    padding: 20px;
    height: 630px;
    overflow-y: auto;
    overflow-x: hidden;

    /deep/ .my_input_layer {
      .el-input {
        flex: 1;
      }
    }

    .line_border {
      margin: 20px 0 0;
      border-top: 1px dashed #efefef;
    }

    /deep/ .my_collapse {
      padding: 10px 0;

      .my_collapse_item_header {
        color: #657180 !important;
      }

      .my_collapse_item_line {
        opacity: 0 !important;
      }
    }

    .checkbox_item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin: 8px 0 11px 18px;
      font-size: 13px;
      color: #333;

      /deep/ .el-checkbox__label {
        color: #333 !important;
      }

      span {
        cursor: pointer;
      }
      /deep/ .tips{
        margin-left:10px;
        line-height:36px;
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 16px;
        text-align: center;
        color: #d8d8d8;
        border: 1px solid #d8d8d8;
        border-radius: 50%;
        cursor: pointer;
        
      }
      
    }
  }

  &.c-custom_setting {
    /deep/ .el-tabs {
    .el-tabs__header {
      .el-tabs__active-bar {
          width: 60px !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/setting.vue